<template>
  <div class="password-setting-container">
    <!-- <h4 class="section-title">账号密码管理</h4> -->

    <div class="password-form">
      <!-- 旧密码 -->
      <div class="password-row">
        <label for="old-password">旧密码</label>
        <input
          type="password"
          id="old-password"
          placeholder="请输入旧密码"
          v-model="formData.oldPassword"
          class="input-field"
        />
      </div>

      <!-- 新密码 -->
      <div class="password-row">
        <label for="new-password">新密码</label>
        <input
          type="password"
          id="new-password"
          placeholder="请输入新密码"
          v-model="formData.newPassword"
          @blur="validatePasswords"
          :class="{ 'input-error': passwordError }"
          class="input-field"
        />
      </div>

      <!-- 确认新密码 -->
      <div class="password-row">
        <label for="confirm-password">确认新密码</label>
        <input
          type="password"
          id="confirm-password"
          placeholder="请再次输入新密码"
          v-model="formData.confirmPassword"
          @blur="validatePasswords"
          :class="{ 'input-error': confirmPasswordError }"
          class="input-field"
        />
      </div>

      <!-- 更新按钮 -->
      <button class="update-button" @click="updatePassword">
        确认修改密码
      </button>
    </div>

    <!-- 提示框 -->
    <MessagePopup
      :visible="showPopup"
      :message="popupMessage"
      :type="popupType"
    />
  </div>
</template>

<script setup>
import MessagePopup from '@/features/message/components/MessagePopup.vue'
import { useUserPasswordSetting } from '@/features/user/composables/useUserPasswordSetting'

const {
  formData,
  passwordError,
  confirmPasswordError,
  popupMessage,
  popupType,
  showPopup,
  validatePasswords,
  updatePassword,
} = useUserPasswordSetting()
</script>

<style scoped src="@/features/user/styles/operationArea/UserPasswordSetting.css"></style>
<style scoped src="@/features/user/styles/operationArea/OperationAreaTheme.css"></style>
